import React from 'react';
import { Skeleton } from '../skeleton/index.js';
import styled, { css } from 'styled-components';
import {} from '@oneaudi/unified-web-alpha-common';
const StyledTextSkeleton = styled(Skeleton) `
  width: ${(props) => props.width ?? '100%'};

  ${(props) => {
    const getHeight = (size) => `${parseInt(size) * (props.lines || 1)}px`;
    if (props.emphasis === 'normal') {
        return css `
        height: ${props.order === '1'
            ? getHeight('24px')
            : props.order === '2'
                ? getHeight('24px')
                : props.order === '3'
                    ? getHeight('20px')
                    : getHeight('12px')};
      `;
    }
    return css `
      height: ${props.order === '1'
        ? getHeight('20px')
        : props.order === '2'
            ? getHeight('20px')
            : getHeight('16px')};
    `;
}}
`;
export const TextSkeleton = ({ order, emphasis = 'normal', width, margin, lines, 'data-testid': dataTestId, className }) => (React.createElement(StyledTextSkeleton, { lines: lines, "data-testid": dataTestId, variant: "oval", order: order, emphasis: emphasis, width: width, margin: margin, className: className }));
//# sourceMappingURL=index.skeleton.js.map